/* Brunelia v3 (18/10/2026): scroll reveal of poster grids,
   slow cross-fade of the home hero photos, HD image for the product hover magnifier (loaded on first hover). */
(function () {
  "use strict";
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var fine = window.matchMedia && matchMedia("(hover: hover) and (pointer: fine)").matches;

  /* cursor: plain CSS arrow since 28/10 (rv-v3.css), no following circle */

  /* ---------- scroll reveal (poster cards) ---------- */
  if ("IntersectionObserver" in window && !reduce) {
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { rootMargin: "0px 0px -6% 0px", threshold: 0.05 });
    var watch = function (root) {
      var cards = (root || document).querySelectorAll(".walls .wallcard:not(.rv-up), .arts .art:not(.rv-up), .art-grid > *:not(.rv-up)");
      var vh = window.innerHeight;
      Array.prototype.forEach.call(cards, function (c, i) {
        var r = c.getBoundingClientRect();
        if (r.top < vh && r.bottom > 0) return; /* already visible: never hide it */
        c.style.setProperty("--d", ((i % 4) * 0.08) + "s");
        c.classList.add("rv-up"); io.observe(c);
      });
    };
    watch();
    /* cards added later (filters, « Voir plus », lazy home sections) */
    new MutationObserver(function (ms) {
      for (var i = 0; i < ms.length; i++) if (ms[i].addedNodes.length) { watch(); break; }
    }).observe(document.getElementById("main") || document.body, { childList: true, subtree: true });
  }

  /* ---------- home hero photos (v3.1): the first photo was drawn at random by the inline script of rv-home-hero;
     the rotation then picks from 60 seed photos + 700 photos of assets/rv-hero-photos.json + shop metafield custom.hero_images,
     shuffled; only the photo shown and the next one are loaded; each photo links to its poster. ---------- */
  var box = document.querySelector("[data-v3-fade]");
  if (box) {
    var C = "https://cdn.shopify.com/s/files/1/0922/2583/1191/";
    var slides = Array.prototype.slice.call(box.querySelectorAll(".v3h-shot")), k = 0, pool = [], seen = {};
    seen[box.getAttribute("data-first") || ""] = 1;
    var cdn = function (u, w) { return u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w; };
    var full = function (s) { return /^https?:/.test(s) ? s : C + s; };
    var mk = function (it) {
      var a = document.createElement(it.href ? "a" : "figure");
      a.className = "v3h-shot"; if (it.href) { a.href = it.href; a.tabIndex = -1; }
      var im = document.createElement("img"); im.alt = it.title || RV.t("v3_js.hero_alt"); im.decoding = "async";
      im.src = cdn(it.src, 800); im.srcset = [400, 600, 800, 1000].map(function (w) { return cdn(it.src, w) + " " + w + "w"; }).join(", "); im.sizes = "(min-width: 960px) 30vw, 92vw";
      a.appendChild(im);
      if (it.title) { var c = document.createElement("span"); c.className = "v3h-cap"; c.textContent = it.title; a.appendChild(c); }
      box.appendChild(a); return a;
    };
    var ensureNext = function () { if (k + 1 >= slides.length && pool.length) slides.push(mk(pool.shift())); };
    var shuffle = function (a) { for (var i = a.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)), t = a[i]; a[i] = a[j]; a[j] = t; } return a; };
    var add = function (list) {
      list.forEach(function (e) {
        var it = Array.isArray(e) ? { src: full(e[0]), href: "/products/" + e[1], title: (document.documentElement.lang !== "fr" && e[3]) || e[2], key: e[0] } : e;
        if (!it.src || seen[it.key || it.src]) return; seen[it.key || it.src] = 1; pool.push(it);
      });
      pool = shuffle(pool); ensureNext();
    };
    try { add(JSON.parse((document.getElementById("rv-hero-seed") || {}).textContent || "[]")); } catch (e) {}
    try {
      var hero = JSON.parse(box.getAttribute("data-hero") || "null") || [];
      add(hero.map(function (x) { return { src: typeof x === "string" ? x : (x && x.url) || "" }; }));
    } catch (e) {}
    var more = function () {
      var u = box.getAttribute("data-list"); if (!u) return;
      fetch(u).then(function (r) { return r.ok ? r.json() : []; }).then(add).catch(function () {});
    };
    if ("requestIdleCallback" in window) requestIdleCallback(more, { timeout: 4000 }); else setTimeout(more, 2500);
    if (!reduce) setInterval(function () {
      if (document.hidden || slides.length < 2) return;
      var nx = (k + 1) % slides.length, im = slides[nx].querySelector("img");
      if (im && !im.complete) return;
      slides[k].classList.remove("on"); slides[k].tabIndex = -1;
      k = nx; slides[k].classList.add("on"); slides[k].tabIndex = 0;
      ensureNext();
    }, 5200);
  }

  /* ---------- product magnifier: HD source on first hover ---------- */
  var gal = document.querySelector("[data-rv-gal]");
  if (gal && fine) {
    var hd = function (img) {
      if (!img) return;
      var src = img.currentSrc || img.src; if (!src) return;
      var key = src.split("?")[0];
      if (img.dataset.v3hd === key) return;
      img.dataset.v3hd = key;
      try {
        var u = new URL(src, location.href);
        u.searchParams.set("width", "2400");
        var pre = new Image();
        pre.onload = function () { img.removeAttribute("srcset"); img.removeAttribute("sizes"); img.src = u.toString(); };
        pre.src = u.toString();
      } catch (e) {}
    };
    gal.addEventListener("mousemove", function () {
      hd(gal.querySelector("[data-rv-gal-frame] img") || gal.querySelector(".ph-full"));
    });
  }

  /* ---------- v3.1 ambient light: the soft blue follows the mouse (mockup brunelia-theme-v3.html), never on touch or reduced motion ---------- */
  var amb = document.querySelector(".rv-ambient");
  if (amb && fine && !reduce) {
    var mx = 70, my = 6, tx = 70, ty = 6, lraf = 0;
    var lightLoop = function () {
      mx += (tx - mx) * 0.06; my += (ty - my) * 0.06;
      amb.style.setProperty("--mx", mx.toFixed(2) + "%"); amb.style.setProperty("--my", my.toFixed(2) + "%");
      lraf = (Math.abs(tx - mx) + Math.abs(ty - my) > 0.1) ? requestAnimationFrame(lightLoop) : 0;
    };
    addEventListener("pointermove", function (e) {
      if (e.pointerType !== "mouse") return;
      tx = e.clientX / innerWidth * 100; ty = e.clientY / innerHeight * 60;
      if (!lraf) lraf = requestAnimationFrame(lightLoop);
    }, { passive: true });
  }

  /* ---------- v3.1 quick add from every product card: sizes loaded from /products/<handle>.js on first click only,
     popover on the card (mouse) or bottom sheet (touch), one choice = added (RV.cart.add: drawer opens, count updated) ---------- */
  var QA = {}, qaOpen = null, sheet = null;
  var esc = function (s) { return String(s == null ? "" : s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
  var money = function (c) { return window.RV && RV.money ? RV.money(c) : (Number(c) / 100).toFixed(2); };
  var fmtOf = function (o) {
    o = String(o || "");
    var m = o.match(/^\s*(A[0-6])\b/i); if (m) return m[1].toUpperCase();
    var n = o.match(/([\d.]+)"\s*x\s*([\d.]+)"/);
    if (n) { var big = Math.max(parseFloat(n[1]), parseFloat(n[2])); return big <= 12 ? "A4" : big <= 17 ? "A3" : big <= 24 ? "A2" : big <= 34 ? "A1" : "A0"; }
    return o.replace(/\s*\(.*$/, "");
  };
  var DIM = { A4: "21 × 29,7 cm", A3: "29,7 × 42 cm", A2: "42 × 59,4 cm", A1: "59,4 × 84,1 cm", A0: "84,1 × 118,9 cm" };
  /* real print size, landscape when the option says so or when its own cm values are wider than tall (audit 18/10) */
  var dimOf = function (o, f) {
    o = String(o || "");
    var m = o.match(/([\d.,]+)\s*×\s*([\d.,]+)\s*cm/); if (m) return m[1] + " × " + m[2] + " cm";
    var d = DIM[f]; if (!d) return "";
    var n = o.match(/([\d.]+)"\s*x\s*([\d.]+)"/) || o.match(/\(([\d.,]+)\s*[×x]\s*([\d.,]+)/);   /* recette-suite 22/10: « A3 (11.7 × 16.5 in) » */
    if (n) n = [n[0], String(n[1]).replace(",", "."), String(n[2]).replace(",", ".")];
    if (/horizontal|landscape|paysage/i.test(o) || (n && parseFloat(n[1]) > parseFloat(n[2]))) { var x = d.replace(" cm", "").split(" × "); return x[1] + " × " + x[0] + " cm"; }
    return d;
  };
  var NOFRAME = '<p class="qa-nf">' + RV.t("v3_js.no_frame") + "</p>";
  var load = function (h) {
    if (!QA[h]) QA[h] = fetch((window.RV && RV.root ? RV.root.replace(/\/$/, "") : "") + "/products/" + encodeURIComponent(h) + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw r; return r.json(); })
      .catch(function (e) { delete QA[h]; throw e; });
    return QA[h];
  };
  var optsHTML = function (p) {
    return p.variants.map(function (v) {
      var f = fmtOf(v.option1), dm = dimOf(v.option1, f);
      return '<button type="button" class="qa-opt" data-v="' + v.id + '" data-f="' + esc(f) + '"' + (v.available ? "" : " disabled") + '><span>' + esc(f) + (dm ? "<small>" + esc(dm.replace(/(\d),(\d)/g, "$1" + RV.t("core_js.dec") + "$2")) + "</small>" : "") + "</span><b>" + money(v.price) + (v.compare_at_price > v.price ? " <s>" + money(v.compare_at_price) + "</s>" : "") + "</b></button>";
    }).join("");
  };
  var closeQA = function (focus) {
    if (qaOpen) {
      var b = qaOpen.btn; if (qaOpen.pop && qaOpen.pop.parentNode) qaOpen.pop.parentNode.removeChild(qaOpen.pop);
      b.setAttribute("aria-expanded", "false"); qaOpen = null; if (focus) b.focus();
    }
    if (sheet && !sheet.hidden) { sheet.hidden = true; document.documentElement.style.overflow = ""; }
  };
  var add = function (btn, id, f) {
    if (!(window.RV && RV.cart)) return;
    var img = btn.getAttribute("data-img");
    closeQA(false);
    RV.cart.add([{ id: Number(id), quantity: 1 }]).then(function () {
      if (RV.toast) RV.toast(RV.t("core_js.added_cart") + (f ? " · " + f : ""), img);
    }).catch(function () {});
  };
  var useSheet = function () { return window.matchMedia && (matchMedia("(hover: none), (pointer: coarse)").matches || innerWidth < 700); };
  var openSheet = function (btn, p) {
    if (!sheet) {
      sheet = document.createElement("div"); sheet.className = "qa-sheet"; sheet.hidden = true;
      sheet.setAttribute("role", "dialog"); sheet.setAttribute("aria-modal", "true"); sheet.setAttribute("aria-label", RV.t("v3_js.choose_format"));
      document.body.appendChild(sheet);
      sheet.addEventListener("click", function (e) {
        if (e.target === sheet || e.target.closest(".qa-sheet-x")) { closeQA(false); if (sheet._btn) sheet._btn.focus(); return; }
        var o = e.target.closest(".qa-opt"); if (o && !o.disabled) add(sheet._btn, o.getAttribute("data-v"), o.getAttribute("data-f"));
      });
    }
    sheet._btn = btn;
    var im = btn.getAttribute("data-img");
    sheet.innerHTML = '<div class="qa-sheet-in"><div class="qa-sheet-h">' + (im ? '<img src="' + esc(im) + '" alt="">' : "") + "<b>" + esc(p.title) + '</b><button type="button" class="qa-sheet-x" aria-label="' + RV.t("core_js.close") + '"><svg width="16" height="16" viewBox="0 0 16 16" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg></button></div>' + NOFRAME + '<div class="qa-opts">' + optsHTML(p) + "</div></div>";
    sheet.hidden = false; document.documentElement.style.overflow = "hidden";
    var first = sheet.querySelector(".qa-opt:not([disabled])"); if (first) first.focus();
  };
  var openPop = function (btn, card, p) {
    var pop = document.createElement("div"); pop.className = "qa-pop"; pop.setAttribute("role", "group"); pop.setAttribute("aria-label", RV.t("v3_js.choose_format"));
    pop.innerHTML = "<p>" + RV.t("v3_js.choose_format") + "</p>" + NOFRAME + optsHTML(p);
    card.appendChild(pop); qaOpen = { btn: btn, pop: pop }; btn.setAttribute("aria-expanded", "true");
    var first = pop.querySelector(".qa-opt:not([disabled])"); if (first) first.focus();
    pop.addEventListener("click", function (e) { var o = e.target.closest(".qa-opt"); if (o && !o.disabled) add(btn, o.getAttribute("data-v"), o.getAttribute("data-f")); });
  };
  document.addEventListener("click", function (e) {
    var btn = e.target.closest && e.target.closest("[data-rv-qa]");
    if (!btn) { if (qaOpen && !e.target.closest(".qa-pop")) closeQA(false); return; }
    e.preventDefault();
    if (qaOpen && qaOpen.btn === btn) { closeQA(true); return; }
    closeQA(false);
    var card = btn.closest(".wallcard") || btn.parentNode, h = btn.getAttribute("data-rv-qa");
    btn.setAttribute("aria-busy", "true");
    load(h).then(function (p) {
      btn.removeAttribute("aria-busy");
      var av = p.variants.filter(function (v) { return v.available; });
      if (p.variants.length === 1 && av.length === 1) { add(btn, av[0].id, ""); return; }
      if (useSheet()) openSheet(btn, p); else openPop(btn, card, p);
    }).catch(function () {
      btn.removeAttribute("aria-busy");
      location.href = (card.querySelector("a.wc-link") || {}).href || "/products/" + h;
    });
  });
  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    if (qaOpen) { closeQA(true); return; }
    if (sheet && !sheet.hidden) { var b = sheet._btn; closeQA(false); if (b) b.focus(); }
  });
  /* technique-site 22/10: the quick-add popup (non-modal) closes when the keyboard focus leaves it */
  document.addEventListener("focusin", function (e) { if (qaOpen && qaOpen.pop && !qaOpen.pop.contains(e.target) && e.target !== qaOpen.btn) closeQA(false); });

  /* ---------- « Voir à l'échelle sur un mur »: the section title lands just under the sticky header ---------- */
  document.addEventListener("click", function (e) {
    var a = e.target.closest && e.target.closest(".rv-scale-go"); if (!a) return;
    var t = document.getElementById("rv-scale-h"); if (!t) return;
    e.preventDefault();
    var h = document.querySelector(".rv-hdr-section") || document.querySelector(".hdr");
    var off = (h ? h.getBoundingClientRect().bottom : 80) + 24;
    scrollTo({ top: scrollY + t.getBoundingClientRect().top - off, behavior: reduce ? "auto" : "smooth" });
    if (history.replaceState) history.replaceState(null, "", "#rv-scale-h");
  });
})();
